export default {
  offlineMode: 'Mode hors ligne',
};
